import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "nav", "toggleButton", "mobileToggleButton", "backdrop"]
  
  connect() {
    // Initialize expanded state
    this.expanded = false
    this.updateToggleIcon()
    
    // Auto-collapse when clicking outside (mobile only)
    this.handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener('click', this.handleClickOutside)
    
    // Auto-collapse on window resize if we're no longer in mobile view
    this.handleResize = this.handleResize.bind(this)
    window.addEventListener('resize', this.handleResize)
    
    // Handle escape key to close mobile menu
    this.handleEscape = this.handleEscape.bind(this)
    document.addEventListener('keydown', this.handleEscape)
  }
  
  disconnect() {
    document.removeEventListener('click', this.handleClickOutside)
    window.removeEventListener('resize', this.handleResize)
    document.removeEventListener('keydown', this.handleEscape)
  }
  
  toggle() {
    this.expanded = !this.expanded
    this.updateState()
    this.updateToggleIcon()
  }
  
  close() {
    if (this.expanded) {
      this.expanded = false
      this.updateState()
      this.updateToggleIcon()
    }
  }

  closeMobile() {
    // Keep this method for backward compatibility with the template
    this.close()
  }
  
  updateState() {
    if (this.expanded) {
      if (this.hasSidebarTarget) {
        this.sidebarTarget.classList.add('simple-sidebar-expanded')
      }
      // Add class to container to hide hamburger button
      this.element.classList.add('sidebar-container-expanded')
      // Show backdrop and prevent scrolling when sidebar is open
      if (this.hasBackdropTarget) {
        this.backdropTarget.classList.add('show')
        document.body.style.overflow = 'hidden'
      }
    } else {
      if (this.hasSidebarTarget) {
        this.sidebarTarget.classList.remove('simple-sidebar-expanded')
      }
      // Remove class from container to show hamburger button
      this.element.classList.remove('sidebar-container-expanded')
      if (this.hasBackdropTarget) {
        this.backdropTarget.classList.remove('show')
        // Restore body scroll
        document.body.style.overflow = ''
      }
    }
  }
  
  updateToggleIcon() {
    // Internal toggle button always shows X (no need to change)
    // External mobile button always shows hamburger (no need to change)
  }
  
  handleClickOutside(event) {
    // Only handle when expanded
    if (!this.expanded) return
    
    // Check if click is outside the sidebar and menu button
    if (this.hasSidebarTarget && !this.sidebarTarget.contains(event.target) && 
        (!this.hasMobileToggleButtonTarget || !this.mobileToggleButtonTarget.contains(event.target))) {
      this.closeMobile()
    }
  }
  
  handleEscape(event) {
    if (event.key === 'Escape' && this.expanded) {
      this.closeMobile()
    }
  }
  
  handleResize() {
    // Auto-collapse if we're no longer in mobile view
    if (!this.isMobileView() && this.expanded) {
      this.expanded = false
      this.updateState()
      this.updateToggleIcon()
    }
  }
  
  isMobileView() {
    return window.innerWidth <= 768
  }
} 
